import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@lib/utils';
import { useMemo } from 'react';

function Label({
  className,
  size = 'sm',
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & { size?: 'sm' | 'xs' }) {
  const textSize = useMemo(() => {
    switch (size) {
      case 'sm':
        return 'text-sm';
      case 'xs':
        return 'text-xs ml-2';
      default:
        return '';
    }
  }, [size]);

  return (
    <LabelPrimitive.Root
      className={cn(
        textSize,
        'flex items-center leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className
      )}
      data-slot="label"
      {...props}
    />
  );
}

export { Label };
